module.exports = __webpack_public_path__ + "static/media/homeMobile.252e7002.png";